export { default } from './Galleries';
